// eslint-disable-next-line eslint-comments/disable-enable-pair
/* eslint-disable i18next/no-literal-string */
import { CurrentUser } from '@lastbrand/fe-common/universal-auth'

import { checkIfGtmIsBlocked } from '@src/quince-site-common/src/utils/checkIsGtmBlocked'
import initialiseDlProxy from '@src/quince-site-common/src/utils/dataLayer.utils'
import {
  validateLbUserId,
  validateSessionId,
  executeOnceIfSessionIsNew,
} from '@src/telemetry/integrations/provider-utils/internal-analytics-utils'
import { TELEMETRY_EVENT_NAMES } from '@src/telemetry/telemetry-events.constants'
import { initializeTelemetry, trackInternalEvent } from '@src/telemetry/track'
import { removeAndSetNewCookies } from '@src/utils/auth.utils'

import mixpanelCl from '../../../telemetry/integrations/mixpanel'
import { ANALYTIC_COOKIES } from '../utils/constants'
import getCurrentUser from '../utils/getCurrentUser'
import initUserAnalyticsCookie from '../utils/init-user-analytics-cookie'

// import { setInLocalStorageWithExpiry } from '../utils/setInLocalStorageWithExpiry'

export default function initialize({ enableTelemetry }: { enableTelemetry: boolean }) {
  // Capturing user information in cookie.
  setCustomerDetailsInCookie()

  // Persisting Session information in cookies.
  validateLbUserId()
  validateSessionId()

  initUserAnalyticsCookie()

  initialiseDlProxy()
  checkIfGtmIsBlocked()
  if (enableTelemetry) {
    initializeTelemetry()
  }

  executeOnceIfSessionIsNew(({ sessionId, lastSessionId }) => {
    trackInternalEvent(TELEMETRY_EVENT_NAMES.SESSION_CREATE, {
      sessionId: sessionId,
      lastSessionId,
    })
  })
}

function setCustomerDetailsInCookie() {
  const user = getCurrentUser() as CurrentUser | null
  if (user?.email) {
    removeAndSetNewCookies(ANALYTIC_COOKIES.LB_CUSTOMER_EMAIL, user.email)
    mixpanelCl.identify({ email: user.email, isTentativeEmail: false })
  }
  if (user?.customerMetadata?.customerId) {
    removeAndSetNewCookies(ANALYTIC_COOKIES.LB_CUSTOMER_ID, user.customerMetadata.customerId)
  }
}
